import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dceacedc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "k-dialog-wrapper",
  tabindex: "0"
}
const _hoisted_2 = {
  class: "k-window k-dialog",
  role: "dialog"
}
const _hoisted_3 = {
  key: 0,
  class: "k-window-titlebar k-dialog-titlebar"
}
const _hoisted_4 = { class: "k-window-title" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "k-window-actions" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  role: "presentation",
  class: "k-icon k-button-icon k-i-x"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "m-container" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 1,
  class: "k-content"
}
const _hoisted_12 = {
  key: 0,
  class: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-light"
}
const _hoisted_13 = {
  key: 1,
  class: "button__left-space k-button k-button-md k-rounded-md k-button-solid k-button-solid-light"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.modalDialogTitle != '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                innerHTML: _ctx.getModalDialogTitle()
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "k-button k-button-md k-rounded-md k-icon-button k-button-flat k-button-flat-base k-window-action k-dialog-action",
                "aria-label": "Close",
                type: "button",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.doOk()), ["prevent"]))
              }, _hoisted_8)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          innerHTML: _ctx.getModalDialogText(),
          class: "m-content"
        }, null, 8, _hoisted_10)
      ]),
      (_ctx.modalDialogText !== '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            (_ctx.modalDialogType == 'versionupdate'|| _ctx.modalDialogType == 'info')
              ? (_openBlock(), _createElementBlock("button", _hoisted_12, [
                  _createElementVNode("span", {
                    class: "k-button-text",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.doOk()), ["prevent"]))
                  }, "     " + _toDisplayString(_ctx.okTitle) + "     ", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.modalDialogType == 'versionupdate')
              ? (_openBlock(), _createElementBlock("button", _hoisted_13, [
                  _createElementVNode("span", {
                    class: "k-button-text",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.doCancel()), ["prevent"]))
                  }, _toDisplayString(_ctx.cancelTitle), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}